class CtrReviewsCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
    this.mobileBreakpoint = 750;
    this.slideSpeed = 400;
    this.handleResize = this.handleResize.bind(this);
    this.handlePrevClick = this.handlePrevClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
  }

  connectedCallback() {
    if (typeof Swiper === 'undefined') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
    this.unbindControls();
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }

  init() {
    this.buildSwiper();
    window.addEventListener('resize', this.handleResize);
  }

  getSpaceBetween() {
    return window.innerWidth < this.mobileBreakpoint ? 16 : 24;
  }

  unbindControls() {
    const prevButton = this.querySelector('[ref="prev"]');
    const nextButton = this.querySelector('[ref="next"]');

    if (prevButton) {
      prevButton.removeEventListener('click', this.handlePrevClick);
    }

    if (nextButton) {
      nextButton.removeEventListener('click', this.handleNextClick);
    }
  }

  bindControls(prevButton, nextButton) {
    this.unbindControls();

    if (prevButton) {
      prevButton.addEventListener('click', this.handlePrevClick);
    }

    if (nextButton) {
      nextButton.addEventListener('click', this.handleNextClick);
    }
  }

  handlePrevClick(event) {
    event.preventDefault();
    this.swiperInstance?.slidePrev(this.slideSpeed);
  }

  handleNextClick(event) {
    event.preventDefault();
    this.swiperInstance?.slideNext(this.slideSpeed);
  }

  buildSwiper() {
    const carousel = this.querySelector('[ref="carousel"]');
    const prevButton = this.querySelector('[ref="prev"]');
    const nextButton = this.querySelector('[ref="next"]');
    const blockCount = parseInt(this.dataset.blockCount, 10) || 0;

    if (!carousel || blockCount < 1 || typeof Swiper === 'undefined') return;

    this.unbindControls();

    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }

    const shouldLoop = blockCount > 1;

    this.swiperInstance = new Swiper(carousel, {
      loop: shouldLoop,
      loopedSlides: shouldLoop ? blockCount : 0,
      loopAdditionalSlides: shouldLoop ? blockCount : 0,
      slidesPerView: 'auto',
      spaceBetween: this.getSpaceBetween(),
      speed: this.slideSpeed,
      allowTouchMove: true,
      simulateTouch: true,
      grabCursor: true,
      touchRatio: 1,
      touchAngle: 45,
      touchStartPreventDefault: false,
      touchMoveStopPropagation: false,
      touchEventsTarget: 'container',
      threshold: 5,
      longSwipesRatio: 0.25,
      followFinger: true,
      resistance: true,
      resistanceRatio: 0.85,
      preventClicks: true,
      preventClicksPropagation: true,
      breakpoints: {
        750: {
          spaceBetween: 24
        }
      }
    });

    this.bindControls(prevButton, nextButton);
  }

  handleResize() {
    if (!this.swiperInstance) return;

    const spaceBetween = this.getSpaceBetween();

    if (this.swiperInstance.params.spaceBetween !== spaceBetween) {
      this.buildSwiper();
      return;
    }

    this.swiperInstance.update();
  }
}

customElements.get('ctr-reviews-carousel') ||
  customElements.define('ctr-reviews-carousel', CtrReviewsCarousel);
